/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
import React, { useContext } from 'react';
import { gql, useQuery } from '@apollo/client';
import { MemberType } from 'types';
import { Link, useParams } from 'react-router-dom';
import Footer from 'components/footer/Footer';
import Nav from 'components/nav/Nav';
import { ArtistContext } from 'context/ArtistContext';
import Loader from '../../components/loader/Loader';
import { Head } from '../../components/Head';

const GET_MEMBER = gql`
  query GET_MEMBER {
    teamMembers(first: 100) {
      createdAt
      name
      instrument
      spotifyLink
      websiteLink
      memberSlug
      miniMemberBio
      tikTokLink
      companyTitle
      fullBio {
        html
      }
      avatarImage {
        url
      }
      instagramLink
      email
      calendlyLink
      phoneNumber
      facebookLink
      soundcloudLink
      pandoraLink
      epkLink
      youtubeLink
      twitterLink
      linkedinLink
      memberBandsInTown
      memberImageGallery(first: 100) {
        url
      }
      memberMusicRelease(first: 100) {
        url
      }
      memberBookingData
      contactList {
        contactName
        contactEmail
        contactTitle
        contactPhone
        contactAddress
        contactGoogleAddressLink
        contactAvatar {
          id
        }
      }
      videoBox {
        videoTitle
        youtubeVideoId
        vimeoVideoId
        youtubePlaylistId
      }
      primaryMember
      memberHeroImage {
        url
      }
      memberIFrame
      order
      memberType
    }
  }
`;

export default function ArtistsPage() {
  const { loading, data } = useQuery(GET_MEMBER);
  const { memberTypeParam } = useParams();
  const artist = useContext(ArtistContext);
  if (!artist) return <div />;
  const { logo } = artist;
  if (loading) return <Loader height="60vh" />;
  const { teamMembers } = data;

  return (
    <>
      <Head metaTitle={memberTypeParam} />
      <Nav />
      {!!teamMembers && (
        <section className="container my-8 px-4">
          <div className="grid">
            <div className="col-12 lg:col-2 flex flex-column align-items-center justify-items-center lg:justify-content-start">
              <img
                src={logo?.url}
                alt=""
                className="w-6 md:w-5 lg:w-8 block animate-col-width"
              />
              {/* <p>{talentSectionTitle}</p> */}
            </div>
            <div className="col-12 lg:col-10 grid animate-col-width ">
              {teamMembers
                .filter(
                  (tm: MemberType) =>
                    tm?.memberType?.toLowerCase() ===
                    memberTypeParam?.toLowerCase(),
                )
                .map((talent: MemberType) => (
                  <Link
                    to={`/1/${memberTypeParam}/${talent.memberSlug}`}
                    className="talent-card col-12 md:col-6 lg:col-4 animate-col-width  no-underline flex align-items-center justify-content-center flex-column"
                    key={talent.memberSlug}>
                    <img
                      src={talent.avatarImage?.url}
                      alt=""
                      className="mini-avatar block mx-auto"
                      style={{
                        objectFit: 'cover',
                        aspectRatio: 1,
                        height: '220px',
                        width: '220px',
                        borderRadius: '50%',
                        transition: 'all 200ms ease',
                      }}
                    />
                    {talent?.name && (
                      <p className="text-center mx-auto uppercase">
                        {talent?.name}
                      </p>
                    )}
                  </Link>
                ))}
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
}
